import { UserActionRequest } from '@weave/schema-gen-ts/dist/schemas/threads-of-success/v2/api.pb';
import { useMutation } from 'react-query';
import { SchemaThreadsOfSuccessServiceV2 } from './service';

export const useUserAction = () =>
  useMutation({
    mutationKey: 'user-action',
    mutationFn: (req: UserActionRequest) => SchemaThreadsOfSuccessServiceV2.UserAction(req),
  });
